import React from 'react'
import { IBreadcrumbSecondaryItem } from '../common/BreadcrumbSecondaryItem'
import BreadcrumbsSecondary from '../common/BreadcrumbsSecondary'

const TemplatePageBreadcrumbs = () => {
  const govCMSHome = process.env.REACT_APP_GOVCMS_HOME
  const items: IBreadcrumbSecondaryItem[] = [
    {
      name: 'Home',
      url: govCMSHome,
      index: 1,
    },
    {
      name: 'Tools & resources',
      url: govCMSHome + '/tools-and-resources',
      index: 2,
    },
    {
      name: 'Templates',
      url: govCMSHome + '/tools-and-resources/templates',
      index: 3,
    },
  ]
  return (
    <>
      <BreadcrumbsSecondary items={items} />
    </>
  )
}

export default TemplatePageBreadcrumbs
